import React from 'react';
import './dashboard-profile.container.sass';
import { DashboardProfileService } from './components/service/dashboard-profile-service';

export const DashboardProfileContainer = () => {
  return (
   <div className='vv-dashboard-profile-container'>
     <DashboardProfileService/>
   </div>
  );
};
